<template>
  <div class="mx-10 ma-5">
    <v-card class="pa-5">
      <div>
        <PageTitle :title="'Stock Transfer Details'" class="pb-5"></PageTitle>
        <TransferDetails></TransferDetails>
      </div>
    </v-card>
  </div>
</template>

<script>
import PageTitle from "@/components/shared/PageTitle";
import TransferDetails from "@/components/stockTransfer/transferDetails";

export default {
  name: "TransferDetailsView",
  components: { PageTitle, TransferDetails },
};
</script>
